export default __webpack_public_path__ + "static/media/bg3.61151182.png";